module.exports = __webpack_public_path__ + "static/media/gplay.0c27fb53.svg";